import styled from 'styled-components';
import { Space, Text, Button, Modal, Checkbox } from '@cashfree-intl/coherent';
import { CUSTOM_COLORS } from 'constants/colors';
import bgImage from 'images/second-day-bg-intro-image.svg';

export const StyledIntroWrapper = styled(Space)`
  background-image: url(${bgImage}),
    linear-gradient(0.34deg, #2d1b9b -25.11%, #22156f 32.52%, #130951 92.49%);
  height: 100%;
  weight: 100%;
  background-size: cover;


  @media only screen and (max-width: 767px) {
    background: linear-gradient(0.34deg, #2d1b9b -25.11%, #22156f 32.52%, #130951 92.49%);
    height: auto;
  }
`;

export const StyledIntroCard = styled(Space)`
  background: linear-gradient(180deg, #ffffff 0%, #d6dcff 100%);
  width: 53.25rem;
  height: auto;
  padding: 3.5rem 2.25rem 3.5rem 2.25rem;
  border-radius: 0.5rem;
  position: relative;

  @media only screen and (max-width: 767px) {
    width: 80%;
    height: auto;
    margin: 3.5rem 2.25rem 3.5rem 2.25rem;
  }
`;

export const StyledSubTitle = styled(Text)`
  font-size: 1.125rem;
  line-height: 1.37rem;
  margin-bottom: ${props => props.marginBottom || '0'};
`;

export const StyledActionButton = styled(Button)<{ background?: string, hideOnMobile?: boolean }>`
  width: fit-content;
  border-radius: 0.375rem;
  ${props =>
    props.background &&
    `
    background-color: ${props.background};
  `}
  height: 2.5rem;

  > div {
    height: 100%;
    align-items: center;
  }
  ${props =>
    props.hideOnMobile &&
    `
    @media (max-width: 768px) {
      display: none;
    }
  `}
`;

export const StyledLinkButton = styled(Button)<{ showOnMobile?: boolean }>`
  width: fit-content;
  height: auto;
  padding: 0;
  min-width: 0;
  ${props =>
    props.showUnderline &&
    `
    text-decoration: underline;
  `}
   ${props =>
    props.showOnMobile &&
    `
    display: none;
    @media (max-width: 768px) {
      display: inline-block;
    }
  `}
`;

export const CornerImage = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 19.125rem;
  height: 19.125rem;

  @media only screen and (max-width: 767px) {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 2rem;
  }
`;

export const StyledScreenWrapper = styled(Space)`
  width: 100%;
  height: 100%;
  padding: 2rem 7.125rem;
  background: ${props => props.theme.COLORS.bgLight};
  overflow: auto;

  @media only screen and (max-width: 767px) {
    padding: 2rem;
  }
`;

export const StyledStepperWrapper = styled(Space)`
  width: 100%;
  height: auto;
  padding: 2rem;
  border-radius: 0.5rem;
  background: ${props => props.theme.COLORS.white};
`;

export const StyledCongratsCard = styled(Space)`
  background: ${CUSTOM_COLORS?.F8F8F8};
  width: 100%;
  min-height: 12.125rem;
  height: 100%;
  padding: 2rem;
  border-radius: 0.5rem;
`;

export const StyledModal = styled(Modal)`
  .ui.embed {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  @media only screen and (max-width: 767px) {
    .ui.embed {
      border-radius: 0.5rem;
    }
  }
`;

export const StyledStepCard = styled(Space)`
  width: 100%;
  height: auto;
  padding: 1.5rem;
  border-radius: 0.5rem;
  border: 0.0625rem solid ${props => props.theme.COLORS.bg};

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledChildren = styled(Space)`
  padding: 1.25rem 0 1.5rem 0;
`;

export const StyledDescription = styled(Text)`
  max-width: 100%;
  @media (max-width: 768px) {
    max-width: 76%;
    text-align:left;
  }
`;

export const StyledDomainCard = styled(Space)`
  width: 22.5rem;
  height: 100%;
  padding: 0.75rem 1.25rem;
  border-radius: 0.5rem;
  border: 0.0625rem solid ${props => props.theme.COLORS.bg};


  @media only screen and (max-width: 767px) {
    width: 100%;
    padding: 0.5rem;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledStep = styled(Space)`
  border-bottom: 0.0625rem solid ${props => props.theme.COLORS.bg};
`;

export const StyledAlertNote = styled(Space)`
  background: ${CUSTOM_COLORS.FFF8EE};
  border: 0.0625rem solid ${CUSTOM_COLORS.FDBA57};
  position: relative;
  padding: 1.75rem 1rem;
  border-radius: 0.5rem;
`;

export const StyledChevron = styled.div`
  width: 0;
  height: 0;
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  border-top: 0.75rem solid ${CUSTOM_COLORS.FDBA57};
  position: absolute;
  top: -0.74rem;
  left: 14.375rem;
  transform: rotate(180deg);

  &::after {
    content: '';
    position: absolute;
    top: -0.88rem;
    left: -0.5rem;
    width: 0;
    height: 0;
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-top: 0.75rem solid #fff8ee;
  }

  @media (max-width: 768px) {
    left: 50%;
    transform: translateX(-50%) rotate(180deg);
  }
`;

export const StyledTag = styled(Space)`
  position: absolute;
  top: 0;
  left: 0;
  width: fit-content;
  padding: 0.125rem 0.5rem;
  border-top-left-radius: 0.45rem;
  border-bottom-right-radius: 0.5rem;
  background: ${props => props.theme.COLORS.warning};
`;

export const StyledScreenModal = styled(Modal)`
  &.ui.modal {
    width: 90%;
    height: 92%;
    max-width: 90%;
    max-height: 92%;
    overflow: auto;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-top: 0.25rem;
`;

export const StyledSpace = styled(Space)`
  display: flex;
  flex-direction: row;

  ${props =>
    props.wrap &&
    `
      flex-wrap: wrap;
    `}

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;


export const StyledColumnSpace=styled(Space)` 
  display: flex;
  flex-direction: row;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;